/* ── Studio Phalsa — About Section JS (parallax + reveal) ───── */
(function () {
  'use strict';

  const section = document.getElementById('sp-about');
  if (!section) return;

  const bg      = section.querySelector('.sp-about__bg');
  const content = section.querySelector('.sp-about__content');

  /* ── Parallax: bg drifts at ~25% of scroll speed ─────────────── */
  function onScroll() {
    const rect     = section.getBoundingClientRect();
    const vh       = window.innerHeight;
    /* progress: 0 when section top is at viewport bottom,
                 1 when section bottom is at viewport top */
    const progress = 1 - (rect.bottom / (vh + rect.height));
    const clampedProgress = Math.max(0, Math.min(1, progress));

    /* Map progress [0,1] → translateY [-12%, 12%] so bg travels 24% total */
    const shift = (clampedProgress * 2 - 1) * 12;
    if (bg) bg.style.transform = 'translateY(' + shift + '%)';
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Reveal content panel on scroll into view ─────────────────── */
  if (content) {
    const io = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          content.classList.add('is-visible');
          io.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    io.observe(section);
  }

})();
